import Vue from '@/setup'

import { cloneDeep } from 'lodash'

import { LogHelper } from '@/helpers'
import { PartnerUtil } from '@/utils/Partner'

export default {
  namespaced: true,

  state() {
    return {
      collective: null,
      incentive: null,
      partner: null,
    }
  },

  getters: {
    getContent: state => key => cloneDeep(state[key]),

    getCollective: (_state, getters) => () => getters.getContent('collective'),

    getCollectiveGroup: (_state, getters, rootState, rootGetters) => () => {
      const contractOwner = rootState.basket.contractOwner
      const persons = rootState.basket.persons

      let personGroup
      if (contractOwner?.personId) {
        personGroup = rootGetters['basket/getPerson'](contractOwner.personId)?.collectivePersonGroup
      } else {
        personGroup = persons[0]?.collectivePersonGroup
      }

      return getters.getCollective()?.personGroups.find(group => group.groupNumber === personGroup)
    },

    getCollectivePattern: (_state, getters) => () => getters.getCollectiveGroup()?.personnelNumberDescriptor?.picture,

    getIncentive: (_state, getters) => () => getters.getContent('incentive'),
    //TODO make functions return value, not functions if there are no parameters
    getPartner: (_state, getters) => () => getters.getContent('partner'),

    isPartnerBroker: (_state, getters) => PartnerUtil.isBroker(getters.getContent('partner')),
  },

  mutations: {
    SET_CONTENT(state, { key, data }) {
      Vue.set(state, key, data)
      if (state[key] !== null) {
        LogHelper.info([`%cSET_CONTENT ${key}`, 'color: lightgreen', state[key]])
      }
    },
  },

  actions: {
    setContent({ commit }, { key, data }) {
      return new Promise(resolve => {
        commit('SET_CONTENT', { data, key })
        resolve(data)
      })
    },

    /**
     * Set (overwrite) the whole collective data
     * @param {CollectiveResponse} data
     * @returns {Promise<CollectiveResponse>}
     */
    setCollective({ dispatch }, data) {
      return dispatch('setContent', { key: 'collective', data })
    },

    /**
     *
     * Set (overwrite) the whole incentive data
     * @param {IncentiveResponse} data
     * @returns {Promise<IncentiveResponse>}
     */
    setIncentive({ dispatch }, data) {
      return dispatch('setContent', { key: 'incentive', data })
    },
  },
}
